import { render } from "./DropzoneModal.vue?vue&type=template&id=408ec322&scoped=true"
import script from "./DropzoneModal.vue?vue&type=script&lang=js"
export * from "./DropzoneModal.vue?vue&type=script&lang=js"

import "./DropzoneModal.vue?vue&type=style&index=0&id=408ec322&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408ec322"]])

export default __exports__